import logo from '../../assets/images/alexa-logo.png'

export default function FallbackPage() {
    return (
        <>
            <div className="side_bg d-flex justify-content-center align-items-center">
                <div className="text-white text-center">
                    <img src={logo} alt="lg" className="img-fluid zoom-animation" />
                </div>
            </div>
        </>
    )
}